import { effect, inject, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { injectQuery } from '@tanstack/angular-query-experimental';
import { FeatureConfigService } from './feature-config.service';
import { FeatureConfigResponseDTO, FiscalCalendarResponseDTO } from '@libs/api';
import { FiscalCalendarQueriesService } from '@portal/app/shared/services/queries/fiscal-calendar-queries.service';
import { FiscalDatePresetService } from '@portal/app/shared/services/fiscal-date-preset.service';

@Injectable({ providedIn: 'root' })
export class FiscalCalendarStateService {
  private readonly featureConfigService = inject(FeatureConfigService);
  private readonly fiscalCalendarQueries = inject(FiscalCalendarQueriesService);
  private readonly fiscalDatePresetService = inject(FiscalDatePresetService);
  readonly fiscalCalendarQuery = injectQuery(() =>
    this.fiscalCalendarQueries.fiscalCalendar()
  );

  readonly ready$ = new BehaviorSubject<boolean>(false);

  constructor() {
    effect(() => {
      if (this.fiscalCalendarQuery.isSuccess()) {
        const data = this.fiscalCalendarQuery.data();
        if (data) {
          this.fiscalDatePresetService.setCalendarData({
            months: data.months,
            quarters: data.quarters,
            years: data.years
          });
        }
        this.onFiscalCalendarQuerySuccess();
      }
    });
  }

  private isFeatureEnabled(): boolean {
    return this.featureConfigService.isFeatureEnabled(
      FeatureConfigResponseDTO.FeatureNameEnum.FiscalCalendar
    );
  }

  onFiscalCalendarQuerySuccess(): void {
    if (!this.ready$.value) {
      this.ready$.next(true);
    }
  }

  isCustomCalendarEnabled(): boolean {
    return (
      this.isFeatureEnabled() &&
      this.fiscalCalendarQuery.data()?.isCustomCalendar === true
    );
  }

  fiscalCalendarData(): FiscalCalendarResponseDTO | undefined {
    return this.fiscalCalendarQuery.isSuccess()
      ? this.fiscalCalendarQuery.data()
      : undefined;
  }
}
